import {
  curry,
  tryCatch,
  when,
  findIndex,
  converge,
  over,
  lensIndex,
  identity,
  always,
} from 'ramda'

/**
 *  Pass in an array, and base on the `findPredicate`,
 *  this will apply `modifyFn` to the one passed the predicate.
 *  And will return the original format of array with modified content
 * @param {bool} findPredicate (findPredicate :: a -> Bool)
 * @param {func} modifyFn (modifyFn :: a -> a)
 * @param {array} source (source :: Array)
 * @returns {array}
 */
export default curry((findPredicate, modifyFn, source) => {
  if (typeof modifyFn !== 'function') {
    console.warn('[findAndModify] modifyFn needs to be a function')
  }
  return tryCatch(
    when(
      source => findIndex(findPredicate)(source) >= 0,
      converge(
        (index, obj) => over(lensIndex(index), modifyFn, obj),
        [findIndex(findPredicate), identity],
      ),
    ),
    always(source),
  )(source)
})
